module.exports = __webpack_public_path__ + "img/HC3021-193.f817326d.jpg";